// Product page - tab function
var tabLinks = document.querySelectorAll(".tablinks");
var tabContent = document.querySelectorAll(".tabcontent");

tabLinks.forEach(function(el) {
  el.addEventListener("click", openTabs);
});

function openTabs(el) {
  var btnTarget = el.currentTarget;
  var tab_id = btnTarget.dataset.tab;
  
  tabContent.forEach(function(el) {
    el.classList.remove("active");
  });
  
  tabLinks.forEach(function(el) {
    el.parentNode.classList.remove("active");
  });
  
  document.querySelector("#" + tab_id).classList.add("active");
  btnTarget.parentNode.classList.add("active");
}

// Collection page - description more button
var js_read_toggle = document.querySelector('.js_read-toggle');
var product_des = document.querySelector('.main-collection-banner .page-hero-caption');
if(js_read_toggle){
  js_read_toggle.addEventListener("click", function () {
    const elem = document.querySelector('.main-collection-banner .page-hero-caption')
    const maxHeight = getComputedStyle(elem).maxHeight;
    this.previousElementSibling.classList.toggle('showall');

    if(maxHeight === '300px') {
      elem.style.maxHeight = '100%';
    } else {
      elem.style.maxHeight = '300px';
    }

    if(this.textContent == 'Read Less'){
      this.innerHTML = "Read More";
    } else {
      this.innerHTML = "Read Less";

    }
  });
}
if (product_des){
  var product_des_height = parseInt(product_des.clientHeight);

  if (product_des_height > 245){
    product_des.style.maxHeight = '300px';
    js_read_toggle.classList.remove('hide');
  } else {
    js_read_toggle.classList.add('hide');
    product_des.style.maxHeight = 'auto';
  }
}

